import { ContactModel } from '@akin-home/contacts';
import { createUserMutation } from '@akin-home/users/frontend';
import { getCreateUserInputFromContact } from './getCreateUserInputFromContact';

interface RequiredUserData {
  sub: string;
  username: string;
}

export const createUserForContact = (
  contact: ContactModel,
  user_data: RequiredUserData
) => {
  return createUserMutation({
    input: getCreateUserInputFromContact(contact, user_data),
  });
};
